//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "S2InputText",
  components: {
    MessageError: () => import("../message/MessageError.vue"),
  },
  props: {
    disabled: Boolean,
    error: Boolean,
    errorMessage: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    value: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      focus: false,
    };
  },
  watch: {
    value(value) {
      this.setValue(value);
    },
  },
  methods: {
    emitValue(event) {
      this.$emit("input", event.target.value);
    },
    setValue(value = this.value) {
      const { text } = this.$refs;
      if (value !== text.value) {
        text.value = value;
        text.blur();
      }
    },
    toggleFocus(focus) {
      this.focus = focus;
    },
  },
};
